import React from 'react'
import {
    StyledBlackFridayBreachContent,
    StyledTitle,
    StyledMessage,
    StyledRegistrationInfo,
    StyledPackage,
    StyledButton,
    StyledButtonCaption,
} from './BlackFridayBreachContent.styled'
import SubscriptionPackage, {
    SubscriptionPackageProps,
} from '../../SubscriptionPackage/SubscriptionPackage'
import { AuthenticationProvider } from '../../../../../user-registration/authentication/AuthenticationProvider'
import { BreachEvent } from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { AuthenticationState } from '@news-mono/web-common'
import { THEWEST_ALL } from '../../../../../user-registration/entitlements/common'
import { createLinkClickEvent } from '../../../createLinkClickHandler'

export interface BlackFridayBreachContentProps {
    title: string
    message: React.ReactNode
    cta: string
    subscriptionPackages?: SubscriptionPackageProps[]

    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
}

export const BlackFridayBreachContent: React.FC<BlackFridayBreachContentProps> = ({
    title,
    message,
    cta,
    subscriptionPackages,
    articleId,
    breachCreativeName,
    breachDeal,
    onEvent,
}) => {
    const { entitlements, isLoggedIn } = useSelector<
        AppState,
        AuthenticationState
    >((state) => state.authentication)

    // a returning user is a user who has registered, logged in, and has not completed a purchase
    const returningUser = isLoggedIn && !entitlements?.includes(THEWEST_ALL)

    return (
        <AuthenticationProvider onEvent={onEvent}>
            {({ createBreachSubscribeClickEvent }) => (
                <StyledBlackFridayBreachContent>
                    <StyledRegistrationInfo>
                        <StyledTitle>{title}</StyledTitle>
                        <StyledMessage>{message}</StyledMessage>

                        <StyledButton
                            onClick={() => {
                                createLinkClickEvent(
                                    breachCreativeName,
                                    breachDeal,
                                    onEvent,
                                )()
                                createBreachSubscribeClickEvent({
                                    articleId,
                                    breachCreativeName,
                                    breachDeal,
                                    returningUser,
                                })()
                            }}
                        >
                            {cta}
                        </StyledButton>
                        <StyledButtonCaption>
                            Offer only available online.
                        </StyledButtonCaption>
                    </StyledRegistrationInfo>
                    <StyledPackage>
                        {subscriptionPackages &&
                            subscriptionPackages.map(
                                (subscriptionPackageItem, index) => {
                                    return (
                                        <SubscriptionPackage
                                            key={index}
                                            articleId={articleId}
                                            breachCreativeName={
                                                breachCreativeName
                                            }
                                            breachDeal={breachDeal}
                                            onEvent={
                                                subscriptionPackageItem.onEvent
                                            }
                                            ribbonTitle={
                                                subscriptionPackageItem.ribbonTitle
                                            }
                                            pretitle={
                                                subscriptionPackageItem.pretitle
                                            }
                                            heading={
                                                subscriptionPackageItem.heading
                                            }
                                            price={
                                                subscriptionPackageItem.price
                                            }
                                            originalPrice={
                                                subscriptionPackageItem.originalPrice
                                            }
                                            priceQualifier={
                                                subscriptionPackageItem.priceQualifier
                                            }
                                            packagePath={
                                                subscriptionPackageItem.packagePath
                                            }
                                            offerCode={
                                                subscriptionPackageItem.offerCode
                                            }
                                            packageType={
                                                subscriptionPackageItem.packageType
                                            }
                                        />
                                    )
                                },
                            )}
                    </StyledPackage>
                </StyledBlackFridayBreachContent>
            )}
        </AuthenticationProvider>
    )
}
BlackFridayBreachContent.displayName = 'BlackFridayBreachContent'

export default BlackFridayBreachContent
